import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 1,
  id: "messageArea",
  class: "messageArea posFi ofs",
  style: {"overscroll-behavior":"contain"}
}
const _hoisted_2 = {
  key: 2,
  class: "messageArea posFi ofs",
  style: {"height":"300px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  class: "centered fs13",
  style: {"margin-top":"100px"}
}, [
  /*#__PURE__*/_createTextVNode(" まだメッセージがありません。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("日程調整に関係のあるやりとりを開始しましょう！ ")
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 3 }
const _hoisted_6 = {
  key: 0,
  class: "responseArea posFi pad5 with_white_bg"
}
const _hoisted_7 = {
  key: 0,
  class: "w100"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"3px","margin-left":"-3px"} }, "テンプレを利用", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`fw600 fr centered fs12 pointer mt3 mr5 ml10`),
  for: "uploadText"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(`fw600 fr centered fs12 mt3 mb5`),
  style: {}
}
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  for: "uploadText",
  class: "AttachFile centered pointer w100 h100 posAb",
  style: {"opacity":"0.8","top":"10px","background":"#212121","display":"none"}
}
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", {
  class: /*#__PURE__*/_normalizeClass(`fs14 centered mt10 whiteColor fw600`)
}, "アップロード", -1)
const _hoisted_18 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_OneMessageContent = _resolveComponent("OneMessageContent")!
  const _component_UserFileImage = _resolveComponent("UserFileImage")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_MessagesLoader = _resolveComponent("MessagesLoader")!
  const _component_ModalTemplates = _resolveComponent("ModalTemplates")!
  const _component_AdRegistrationModal = _resolveComponent("AdRegistrationModal")!
  const _component_EmailNameFieldsModal = _resolveComponent("EmailNameFieldsModal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.rm.currentMessageRoom && _ctx.currentMessages)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onDragover: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.checkDrag($event, 'new', true)), ["prevent"])),
          onDragleave: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.checkDrag($event, 'new', false)), ["prevent"])),
          onDrop: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)), ["prevent"]))
        }, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.currentMessages.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentMessages, (message, messageindex) => {
                  return (_openBlock(), _createBlock(_component_OneMessageContent, {
                    key: `${message.id}${messageindex}${message.created_at}${(_ctx.rm.currentMessageRoom.members || []).map(
                        m => m.last_read_at
                    )}`,
                    message: message,
                    room: _ctx.rm.currentMessageRoom,
                    onResend: _ctx.resend,
                    onChangeUnsent: _ctx.changeUnsent,
                    onShowPreview: _ctx.showPreview
                  }, null, 8, ["message", "room", "onResend", "onChangeUnsent", "onShowPreview"]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4)),
          (!_ctx.isSuspend)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (!_ctx.isSP)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (!_ctx.Util.isPublic())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("label", {
                              class: _normalizeClass(`circle_button fw600 fl centered fs12 blueAround`),
                              style: {"width":"120px","padding":"4px 10px","margin-bottom":"5px"},
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.useTemplate && _ctx.useTemplate(...args)))
                            }, _hoisted_9),
                            (!_ctx.userFiles || (_ctx.userFiles && _ctx.userFiles.length < _ctx.Const.uploadFileLimit()))
                              ? (_openBlock(), _createElementBlock("label", _hoisted_10, [
                                  _withDirectives(_createElementVNode("img", {
                                    src: _ctx.$getAssetImageUrl(`/assets/icons/clip.png`),
                                    width: "20",
                                    height: "22",
                                    style: {"margin-top":"1px"},
                                    alt: "ファイルを添付"
                                  }, null, 8, _hoisted_11), [
                                    [
                                      _directive_tooltip,
                                      `ファイルを添付`,
                                      void 0,
                                      { top: true }
                                    ]
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.userFiles && _ctx.userFiles.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userFiles, (file, fileindex) => {
                                    return (_openBlock(), _createBlock(_component_UserFileImage, {
                                      key: fileindex,
                                      file: file,
                                      showDeleteButton: true,
                                      type: `narrow`,
                                      class: _normalizeClass(`fr`),
                                      onDeleted: _ctx.deletedAttachment,
                                      onShowPreview: _ctx.showPreview
                                    }, null, 8, ["file", "onDeleted", "onShowPreview"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_TextareaTag, {
                        placeholder: "メッセージを送信",
                        style: {"min-width":"calc(100% - 68px)","border-radius":"8px","text-indent":"0","resize":"none","line-height":"21px"},
                        class: "fl fs14 roundForm",
                        value: _ctx.typedMessage,
                        id: "messageText",
                        onInputValue: _ctx.inputMessage,
                        onKeydown: [
                          _withKeys(_withModifiers(_ctx.pressShift, ["meta"]), ["enter","native"]),
                          _withKeys(_withModifiers(_ctx.pressShift, ["shift"]), ["enter","native"])
                        ]
                      }, null, 8, ["value", "onInputValue", "onKeydown"]),
                      _createElementVNode("section", {
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args))),
                        class: _normalizeClass(`posAb ${_ctx.typedMessage || _ctx.hasAttachment ? `skyblueBg pointer hoverDskyblueBg` : `lgreyBg`}`),
                        alt: "送信",
                        style: {"right":"14px","bottom":"11px","height":"48px","width":"48px","border-radius":"50%"}
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/sendMessage.png`),
                          width: "28",
                          height: "28",
                          class: "pointer",
                          style: {"margin-top":"10px","margin-left":"8px"}
                        }, null, 8, _hoisted_13)
                      ], 2)
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "responseArea posFi w100 skyblueBg whiteColor fw600 centered",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.inputStart && _ctx.inputStart(...args)))
                    }, _toDisplayString(_ctx.$t(`title.write_a_comment`)), 1))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("label", _hoisted_14, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/icons/upload_wt.png`),
              width: "43",
              height: "45",
              style: {"margin-top":"180px"}
            }, null, 8, _hoisted_15),
            _hoisted_16,
            _hoisted_17,
            _createElementVNode("input", {
              type: "file",
              class: "drop__input",
              style: {"display":"none"},
              id: "uploadText",
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
            }, null, 32)
          ])
        ], 32))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createVNode(_component_MessagesLoader)
        ])),
    (!_ctx.isSP)
      ? (_openBlock(), _createBlock(_component_ModalTemplates, {
          key: 2,
          members: _ctx.rm.currentMessageRoom ? _ctx.rm.currentMessageRoom.members : null,
          appo: _ctx.rm.currentRoom ? _ctx.rm.currentAppointment : null,
          onDecideTemplate: _ctx.decideTemplate
        }, null, 8, ["members", "appo", "onDecideTemplate"]))
      : _createCommentVNode("", true),
    _createVNode(_component_AdRegistrationModal, { addFrom: `テンプレ guest` }),
    _createVNode(_component_EmailNameFieldsModal, {
      typedMessage: _ctx.typedMessage,
      room: _ctx.rm.currentMessageRoom,
      onSentEmailName: _ctx.sentEmailName
    }, null, 8, ["typedMessage", "room", "onSentEmailName"])
  ]))
}